<template>
<div id="myCustom" class="myCustom">
  <Header />

  <div id="header-navi" class="header-navi">
    <h2 class="header-navi__ttl">MY CUSTOM</h2>
  </div>

  <div class="myCustom__edit" v-if="!isHideList">
    <div class="myCustom__edit__btn" @click="toggleMode">{{ editLabel }}</div>
  </div>

  <div class="myCustom__items">
    <div class="myCustom__items__notFound" v-if="isHideList">
      カスタム商品がありません
    </div>
    <div class="myCustom__items__ct"
      :class="{ 'is-deleteMode': isDeleteMode }"
      v-if="!isHideList">
      <div v-for="(customItem, index) in customItems"
        :key="index"
        v-if="(customItem['deleteState'] == false && customItem['cartInState'] == false)"
        @click="gotoCustomView(customItem)"
        class="myCustom__items__ct__item"
        :class="{ 'is-notEdit': (customItem['signageState']) }">
        <div class="myCustom__items__ct__item__img">
          <img :src="customItem['customImage'][0]['filename']" :alt="customItem['customImage'][0]['label']">
        </div>
        <div class="myCustom__items__ct__item__txt">
          <div class="myCustom__items__ct__item__txt__logo">
            <img :src="customItem['brandMainImage']" :alt="customItem['brandName']">
          </div>
          <div class="myCustom__items__ct__item__txt__ttl">{{ customItem['name'] }}</div>
          <div class="myCustom__items__ct__item__txt__date">update: {{ customItem['lastUpdate'] | convertDate }}
            <span>{{ showSignageState(customItem) }}</span>
          </div>
        </div>
        <div
        class="myCustom__items__ct__item__menu"
        @click="updateState(customItem)"
        v-if="(!customItem['cartInState'] || !customItem['signageState'])">
          <img src="@/assets/images/mycustom/mycustom-icn-delete.svg" alt="delete">
        </div>
      </div>
    </div>
  </div>

  <Footer />
</div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import customMgr from '@/modules/CustomManager.js'

export default {
  components: {
    Header,
    Footer
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getAllCustomItems().then((customItems) => {
      next(vm => vm.setCustomItems(customItems))
    }).catch(() => {
      next({ name: 'not-found' })
    })
  },
  data () {
    return {
      customItems: [],
      isDeleteMode: false
    }
  },
  filters: {
    convertDate (intTime) {
      const d = new Date(intTime)
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()

      return (year + '.' + month + '.' + day)
    }
  },
  computed: {
    editLabel () {
      if (this.isDeleteMode) return 'Edit End'
      else return 'Edit'
    },
    isHideList () {
      let allCustomItemLength = 0
      const hideCustomItems = this.customItems.filter((element, index, array) => {
        allCustomItemLength++
        return (element['deleteState'] === true || element['cartInState'] === true)
      })

      if (hideCustomItems.length === allCustomItemLength) return true
      else return false
    }
  },
  methods: {
    setCustomItems (customItems) {
      this.customItems = customItems
    },
    updateState (customItem) {
      customItem['deleteState'] = true
      customMgr.setCustomItemValue(customItem['customID'], 'deleteState', customItem['deleteState'])
    },
    showSignageState (customItem) {
      if (customItem['signageState']) return 'スマートミラー連携中'
    },
    toggleMode () {
      this.isDeleteMode = !this.isDeleteMode
    },
    gotoCustomView (customItem) {
      if (Boolean(customItem['cartInState']) === false && Boolean(customItem['signageState']) === false && this.isDeleteMode === false) {
        this.$router.push({ name: 'custom', query: { customid: customItem['customID'] } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-navi {
  @include customTitle;
}
.myCustom {
  &__edit {
    background-color: rgba($dark-gray, 0.6);
    &__btn {
      cursor: pointer;
      color: $base-white;
      font-size: 14px;
      padding: 10px 15px;
      text-align: right;
    }
  }
  &__items {
    &__notFound {
      widows: 100%;
      height: 65vh;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__ct {
      min-height: 65vh;
      padding-bottom: 60px;
      $this: &;
      &.is-deleteMode {
        #{$this}__item {
          &::after {
            display: none;
          }
          &__menu {
            display: block;
          }
        }
      }
      &__item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 15px;
        border-bottom: 1px solid $right-gray;
        position: relative;
        cursor: pointer;

        &.is-notEdit {
          opacity: 0.5;
          pointer-events: none;
          background: #bfbfbf;
          &::after {
            content: none;
          }
        }
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          right: 15px;
          width: 16px;
          height: 16px;
          background: url('../assets/images/mycustom/mycustom-right.svg') top left no-repeat;
          background-size: 16px 16px;
          margin-top: -8px;
        }
        &__img {
          width: 100px;
          height: 100px;
          margin-right: 15px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        &__txt {
          flex: 1;
          overflow: hidden;
          padding-right: 30px;
          &__logo {
            width: 150px;
            height: 20px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              object-position: left;
            }
          }
          &__ttl {
            margin-top: 8px;
            font-size: 15px;
            line-height: 1.5;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &__date {
            font-size: 12px;
            margin-top: 8px;
            color: $dark-gray;
          }
        }

        &__menu {
          display: none;
          position: absolute;
          right: 20px;
          top: calc(50% - 10px);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MyCustom.vue